import i from './order-detail-customer.container';

export default i;
